// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function Make(Config) {
  var t = React.createContext(Config.defaultValue);
  var make = t.Provider;
  var Provider = {
    make: make
  };
  var use = function (param) {
    return React.useContext(t);
  };
  return {
          t: t,
          Provider: Provider,
          use: use
        };
}

export {
  Make ,
}
/* react Not a pure module */
